export default __webpack_public_path__ + "static/media/geisha.4c5d4318.jpg";